<div class="contact-card">
    <div class="container">
        <div class="row align-items-center flex-wrap h-100">
            <div class="col-md-6">
                <img src="assets/img/cta_black_minty.svg" alt="" width="400rem">
            </div>
            <div class="col-md-6 move-text-right">
                <h2 class="font-600 h2-text">
                    Upgrade Your Setup to a Simpler Level
                </h2>
                <br>
                <button type="button" class="btn brand-button" routerLink="/contact-us">Connect to Simplify
                    <img src="assets/img/arrow-white.svg" alt="" class="arrow-in-button">
                </button>
            </div>
        </div>
    </div>
</div>